<template>
  <div>
    <!--国际物流维护  -->
    <baseBreadcrumb :page="$t('message.listMaintenance')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="btn">
        <!-- 新增 -->
        <el-button type="primary" size="small" @click="add">
          {{ $t("message.add") }}</el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- NO -->
          <el-table-column align="center" label="NO" prop="rowNumber" width="80">
          </el-table-column>
          <!-- 排序 -->
          <el-table-column align="center" :label="$t('message.sort')" prop="sort" width="80">
          </el-table-column>
          <!-- 榜单名称（中文） -->
          <el-table-column align="center" :label="$t('message.listNameChinese')" prop="name_cn">
          </el-table-column>
          <!-- 榜单名称（日文） -->
          <el-table-column align="center" :label="$t('message.listNameJapanese')" prop="name_ja">
          </el-table-column>
          <!-- 1688货盘ID -->
          <el-table-column align="center" :label="$t('message.Pallet1688ID')" prop="product_collection_id">
          </el-table-column>
          <!-- 日文榜单说明 -->
          <el-table-column align="center" :label="$t('message.JapaneseRankingExplanation')" prop="tips">
          </el-table-column>

          <!-- 启用状态 -->
          <el-table-column align="center" :label="$t('message.enablingStatus')" prop="status_name">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber">
            <template slot-scope="scope">
              <!-- 修改 -->
              <el-button size="mini" type="primary" class="primary" @click="edit(scope.row)">{{ $t("message.edit")
                }}</el-button>
              <!-- 删除 -->
              <el-button size="mini" type="primary" class="dark" @click="rankingDelete(scope.row.id)">
                {{ $t("message.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增 修改 -->
    <el-dialog :title="name" :close-on-click-modal="false" :visible.sync="addDialogVisible" width="600px" center>
      <el-form :model="formData" :rules="rules" ref="formData" label-width="160px" class="demo-ruleForm">
        <!-- 榜单名称（中文） -->
        <el-form-item :label="$t('message.listNameChinese')" prop="name_cn">
          <el-input v-model="formData.name_cn"></el-input>
        </el-form-item>
        <!-- 榜单名称（日文） -->
        <el-form-item :label="$t('message.listNameJapanese')" prop="name_ja">
          <el-input v-model="formData.name_ja"></el-input>
        </el-form-item>
        <!--排序 -->
        <el-form-item :label="$t('message.sort')" prop="sort">
          <el-input v-model="formData.sort"></el-input>
        </el-form-item>
        <!-- 1688货盘ID-->
        <el-form-item :label="$t('message.Pallet1688ID')" prop="product_collection_id">
          <el-input v-model="formData.product_collection_id"></el-input>
        </el-form-item>
        <!-- 日文榜单说明-->
        <el-form-item :label="$t('message.JapaneseRankingExplanation')" prop="tips">
          <el-input v-model="formData.tips" type="textarea"></el-input>
        </el-form-item>
        <!--启用状态 -->
        <el-form-item :label="$t('message.enablingStatus')" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="addDialogVisible = false">
          {{ $t("message.cancel") }}</el-button>
        <!-- 确定 -->
        <el-button type="primary" @click="rankingStore" v-if="isAdd">
          {{ $t("message.save") }}</el-button>
        <!-- 修改 -->
        <el-button type="primary" @click="rankingUpdate" v-else>
          {{ $t("message.save") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      addDialogVisible: false,
      formData: {},
      name: '',
      isAdd: false,
      rules: {
        name_cn: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        name_ja: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        product_collection_id: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        sort: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        status: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        tips: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
      }
    };
  },
  created() {
    this.rankingList();
  },
  methods: {
    // 列表
    rankingList() {
      this.$api.siteConfiguration.rankingList({ pageSize: 99 }).then((res) => {
        this.tableData = res.data.data;
      });
    },

    // 显示新增
    add() {
      this.name = this.$t("message.add")
      this.isAdd = true
      this.addDialogVisible = true;
      this.formData = {
        status: 1
      }
    },
    // 显示修改
    edit(item) {
      this.name = this.$t("message.edit")
      this.isAdd = false
      this.addDialogVisible = true;
      this.formData = JSON.parse(JSON.stringify(item))
    },
    // 新增
    rankingStore() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration
            .rankingStore(this.formData)
            .then((res) => {
              this.$message.success(res.msg)
              this.addDialogVisible = false;
              this.rankingList();
            });
        }
      })
    },
    // 修改
    rankingUpdate() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration
            .rankingUpdate(this.formData)
            .then((res) => {
              this.$message.success(res.msg)
              this.addDialogVisible = false;
              this.rankingList();
            });
        }
      })
    },
    //删除
    rankingDelete(id) {

      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.siteConfiguration.rankingDelete({ id }).then((res) => {
            this.$message.success(res.msg)

            this.rankingList();
          });
        })
        .catch(() => { });
    },

  },
};
</script>
<style lang='scss' scoped>
.body {
  position: relative;
}

.btn {
  margin-bottom: 20px;
  text-align: right;
  position: absolute;
  top: -60px;
  right: 20px;
}

.row {
  margin: 0 24px;
  padding: 24px;
  display: flex;
  background-color: #f8f8f8;

  .label {
    flex: 1;
    margin-right: 20px;
    line-height: 42px;
  }

  .val {
    flex: 4;
  }
}
</style>